<template>
  <g>
    <text
      v-for="(part, index) in parts"
      :key="index"
      :y="y"
      :dy="lineHeight * index - 5 + index * index * .5"
      :x="x"
      :font-size="fontSize"
      :fill="fill"
      text-anchor="middle"
    >
      {{part}}
    </text>
  </g>
</template>

<script>
export default {
  name: 'TextInABox',
  props: {
    text: {
      type: String,
      default: ''
    },
    textValue: {
      type: String,
      default: ''
    },
    fill: {
      type: String,
      default: '#fff'
    },
    bbox: {
      type: Array,
      default () { return [0, 0, 1, 1] }
    }
  },
  computed: {
    parts () {
      const threshold = this.text.length / 2 - 2
      const chunks = this.text.split(' ')
      let previous = ''
      let index = 0
      let parts = []
      for (let i = 0; i < chunks.length; i++) {
        let p = previous + ' ' + chunks[i]
        if (i === chunks.length - 1) {
          parts[index] = previous ? p : chunks[i]
        } else if (p.length > threshold) {
          if (i) {
            parts[index] = previous
            previous = chunks[i]
          } else {
            parts[index] = p
            previous = ''
          }
          index++
        } else {
          previous = p
        }
      }
      parts.push(this.textValue)
      return parts
    },
    x () {
      return this.bbox[0] * 10.5 //13.856 is the safe constant
    },
    y () {
      return this.bbox[1] * 16
    },
    fontSize () {
      return this.bbox[2] * 35 / Math.max.apply(Math, this.parts.map(p => p.length || 0))
    },
    lineHeight () {
      return this.bbox[3] * this.fontSize * 3.8 / this.parts.length
    }
  }
}
</script>

<style>
</style>
